"use client";

import { CapabilityPage } from "@/components/sections/page-composer";
import { portalData } from "@/lib/data/developers-portal";

export function PortalPage() {
  return <CapabilityPage data={portalData} />;
}
